import { render, staticRenderFns } from "./listaExames.vue?vue&type=template&id=31d09a1e&scoped=true"
import script from "./listaExames.vue?vue&type=script&lang=js"
export * from "./listaExames.vue?vue&type=script&lang=js"
import style0 from "./listaExames.vue?vue&type=style&index=0&id=31d09a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d09a1e",
  null
  
)

export default component.exports